import React from "react";
import { Spinner } from "react-bootstrap";
import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import auth from "../../init.firebase";

const VerifyRoute = ({ children }) => {
  const [user, loading, error] = useAuthState(auth);

  const location = useLocation();
  if (loading) {
    return <Spinner animation="border" variant="primary"></Spinner>;
  }
  if (!user?.emailVerified) {
    toast.warning("Your email is not verified");
    return (
      <Navigate
        to="/verification"
        state={{ from: location }}
        replace
      ></Navigate>
    );
  }
  return children;
};

export default VerifyRoute;
